module.exports = __webpack_public_path__ + "icons/original/small/small-a5.a7e023b76efb421fce243698ec5c1172.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a5.png
// module id = uVvn
// module chunks = app